// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"menuButton_avatarWrapper__Br7IO"};